export const DEFAULT_SORT = {
  field: 'name',
  order: 'ascend',
};
export const SORT_NAME_MAPPING = {
  phone_number: 'phone',
  role_name: 'role',
};
